import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AppInitializerService } from './core/services/app-initializer.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  constructor(appInitializer: AppInitializerService) {
    appInitializer.initApp();
  }
}
